import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Every supplier with the Ship & Debit module enabled, with a summary of what is
 * configured. Same set the 849 engine can resolve — see SdSupplierAdminService.
 */
export function useSdSuppliers() {
  return useQuery(
    orpc.shipAndDebit.sdSuppliers.list.queryOptions({ input: {} }),
  );
}

/** One supplier's full module config (skips until a supplier is selected). */
export function useSdSupplier(companyId: string | undefined) {
  return useQuery(
    orpc.shipAndDebit.sdSuppliers.get.queryOptions({
      input: companyId ? { companyId } : skipToken,
    }),
  );
}

/**
 * What the attachment-role labels say about where this supplier puts its decision.
 * Read-only evidence for a human; see SupplierLabelEvidencePanel.
 */
export function useSdSupplierLabelEvidence(companyId: string | undefined) {
  return useQuery(
    orpc.shipAndDebit.sdSuppliers.labelEvidence.queryOptions({
      input: companyId ? { companyId } : skipToken,
    }),
  );
}

/**
 * The supplier's 849 configurations in the order the engine tries them, with
 * each one's score and history (#7648). Read-only.
 */
export function useSdSupplierConfigRanking(companyId: string | undefined) {
  return useQuery(
    orpc.shipAndDebit.sdSuppliers.configRanking.queryOptions({
      input: companyId ? { companyId } : skipToken,
    }),
  );
}
